import { useContext, useEffect, useMemo } from 'react';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { SessionContext } from '../../../Contexts/SessionContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SurveyDistributionChart from '../../../TripRateNew/SurveyDistrobutionChart';
import { Box, Skeleton } from '@mui/material';
import { FetchAction, useTripRateContext } from '../../TripRateContext';
import useData from '../../../Utilities/Hooks/UseData';
import { getFilteredSurveys } from '../../../TripRateNew/TriprateFilters';

export default function AvailableDates() {
    const { sessionState, setSessionField } = useContext(SessionContext);
    const { surveys, loading: surveysLoading } = useTripRateContext();
    const isMultiModal = sessionState.landusePage.isMultiModal ?? false;
    const { data: dates, loading: datesLoading } = useData<Date[] | null>('TripRateFilterNew', `GetDates?landUse=${sessionState.tripRateMain}&subuse=${sessionState.tripRateSub}&isMultiModal=${isMultiModal}`);
    const loading = datesLoading || surveysLoading;

    console.log(sessionState)

    const setStartDate = (value: dayjs.Dayjs | null) => {
        setSessionField('landusePage.startDate', value);
        setSessionField('primaryFilters.startDate', value?.toDate() ?? null);
    };

    const setEndDate = (value: dayjs.Dayjs | null) => {
        setSessionField('landusePage.endDate', value);
        setSessionField('primaryFilters.endDate', value?.toDate() ?? null);
    };

    const filteredSurveys = useMemo(() => {
        const list = getFilteredSurveys(surveys, { fetchAction: '' as FetchAction });
        return list.map(m => m.rawDate);
    }, [surveys, sessionState.primaryFilters, sessionState.secondaryFilters]);

    const dateRange = useMemo(() => {
        if (!dates || dates.length === 0) return null;
        const sorted = [...dates].sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
        return {
            start: new Date(sorted[0]),
            end: new Date(sorted[sorted.length - 1]),
        };
    }, [dates]);

    useEffect(() => {
        if (!dateRange) return;

        const start = dayjs(dateRange.start);
        const end = dayjs(dateRange.end);
        setSessionField('landusePage.startDate', start);
        setSessionField('landusePage.endDate', end);
        setSessionField('primaryFilters.startDate', start.toDate());
        setSessionField('primaryFilters.endDate', end.toDate());
    }, [dateRange]);

    const startDateMin = dayjs(dateRange?.start ?? new Date()).startOf('year');
    const endDateMax = dayjs(dateRange?.end ?? new Date());

    return (
        <>
            <Grid container component={Paper} size={12} height="100%">
                <Typography>
                    <b>Available Survey Dates:</b>  <Box
                        sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            ml: 0.5,
                            minWidth: 30,
                            height: 25,
                        }}
                    >
                        {loading ? <Skeleton width={150} height={24} /> : dayjs(dateRange?.start).format('DD/MM/YYYY') + "-" + dayjs(dateRange?.end).format('DD/MM/YYYY')}
                    </Box>
                </Typography>
                <SurveyDistributionChart dates={filteredSurveys} loading={loading} startDate={dateRange?.start ?? new Date()} endDate={dateRange?.end ?? new Date()} />
                <Grid size={12}>
                    <Typography>Selected Dates</Typography>
                </Grid>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en-gb'}>
                    <Grid size={6}>
                        <DatePicker
                            label="Start Date"
                            value={sessionState.landusePage.startDate}
                            onChange={setStartDate}
                            onYearChange={(newValue) => setStartDate(newValue.startOf('year'))}
                            disabled={loading}
                            views={['year', 'month', 'day']}
                            openTo="year"
                            yearsOrder="desc"
                            minDate={startDateMin}
                            maxDate={sessionState.landusePage.endDate ?? undefined}
                        />
                    </Grid>
                    <Grid size={6}>
                        <DatePicker
                            label="End Date"
                            value={sessionState.landusePage.endDate}
                            onChange={setEndDate}
                            disabled={loading}
                            views={['year', 'month', 'day']}
                            openTo="year"
                            yearsOrder="desc"
                            minDate={sessionState.landusePage.startDate ?? undefined}
                            maxDate={endDateMax}
                        />
                    </Grid>
                </LocalizationProvider>
            </Grid>
        </>
    );
}

